import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c39fd09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "bg-white rounded mt-4" }
const _hoisted_3 = { class: "BlacklistTable" }
const _hoisted_4 = { class: "flex items-center justify-end py-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка...", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка произошла ошибка", -1))
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 1,
  class: "WhatsappTable"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_12 = { class: "flex items-center justify-end pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_modal = _resolveComponent("modal")!
  const _component_crm_blacklist_filters = _resolveComponent("crm-blacklist-filters")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.create_modal_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          title: "Добавить в черный список",
          class: "medium",
          loading: _ctx.create_modal_state.is_loading,
          onCancel: _ctx.onCreateClose,
          onConfirm: _ctx.onCreateRecord
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_select, {
              placeholder: "Тип идентификатора",
              disabled: _ctx.create_modal_state.is_loading,
              searchable: false,
              options: _ctx.BLACKLIST_TYPES,
              value: _ctx.create_modal_state.typeId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.create_modal_state.typeId) = $event)),
              "is-invalid": _ctx.create_modal_state_form$.typeId.$error,
              "validation-errors": _ctx.create_modal_state_form$.typeId.$errors
            }, null, 8, ["disabled", "options", "value", "is-invalid", "validation-errors"]),
            _createVNode(_component_new_input, {
              class: "mt-4",
              placeholder: _ctx.identifierPlaceholder,
              disabled: _ctx.create_modal_state.is_loading,
              value: _ctx.create_modal_state.identifier,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.create_modal_state.identifier) = $event)),
              "is-invalid": _ctx.create_modal_state_form$.identifier.$error,
              "validation-errors": _ctx.create_modal_state_form$.identifier.$errors
            }, null, 8, ["placeholder", "disabled", "value", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.delete_modal_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          title: "Удалить из черного списка",
          class: "medium",
          "confirm-message": `Вы действительно хотите удалить запись №${_ctx.delete_modal_state.recordId}?`,
          "is-confirm": true,
          loading: _ctx.delete_modal_state.is_loading,
          onCancel: _ctx.onDeleteClose,
          onConfirm: _ctx.onDeleteRecord
        }, null, 8, ["confirm-message", "loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createVNode(_component_crm_blacklist_filters, {
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (
                            _ctx.havePermissions([
                                'notification.black-lists.create',
                                'all-root-permission',
                            ])
                        )
            ? (_openBlock(), _createBlock(_component_new_button, {
                key: 0,
                type: "button",
                class: "mr-4",
                onClick: _ctx.onCreate
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" Добавить ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_new_limit, {
            disabled: _ctx.state.is_loading,
            value: _ctx.state.pagination.limit,
            "total-items": _ctx.state.pagination.total_items,
            onChange: _ctx.onLimitChange
          }, null, 8, ["disabled", "value", "total-items", "onChange"]),
          _createVNode(_component_new_pagination, {
            class: "ml-6",
            disabled: _ctx.state.is_loading,
            "current-page": _ctx.state.pagination.page,
            "total-pages": _ctx.state.pagination.total_pages,
            onChangePage: _ctx.onChangePage
          }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
        ]),
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_7
                  ], 64))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_8,
                      _createVNode(_component_new_button, {
                        class: "mt-1",
                        onClick: _ctx.loadRecords
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Перезагрузить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Список пуст"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_new_table, {
                columns: _ctx.TABLE_COLUMNS,
                rows: _ctx.state.list
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'actions')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (
                                        _ctx.havePermissions([
                                            'notification.black-lists.delete',
                                            'all-root-permission',
                                        ])
                                    )
                          ? (_openBlock(), _createBlock(_component_new_button, {
                              key: 0,
                              type: "button",
                              class: "NewButton--danger",
                              onClick: ($event: any) => (_ctx.onDelete(row.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (column.key === 'createdAt')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                        ], 64))
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ])
    ])
  ]))
}